import React, { useState } from "react";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../../helper";
import client from "../../../api";

const SendTestMessageModelWindow = (props) => {
    const api = client();
    const [loading, setLoading] = useState(false);
    const [email,setEmail] = useState('');
    const [error,setError] = useState('');

    const inputFieldChange = (e) => {
        setEmail(e.target.value);
    }

    const onBlur = (e) => {
        if(e.target.value === ''){
            setError('To Field is required');
        } else if(!(/\S+@\S+\.\S+/.test(e.target.value))){
            setError('Please enter a valid email ');
        }        
    }

    const onFocus = () => {
        setError('');
    }

    const convertHtmlToPlainText = (html) => {
        const element = document.createElement('div');
        element.innerHTML = html;
        return element.innerText || element.textContent;
    };

    const actionSendTestMessage = async () => {
        if(props.steps[props.selectedStepIndex].subject === '' && props.steps[props.selectedStepIndex].body === ''){
         notifyErrorInBottom('Please fill Subject and message body');
         return;
        } else if (props.steps[props.selectedStepIndex].subject === ''){
            notifyErrorInBottom('Please fill the Subject Field');
            return;
        } else if(props.steps[props.selectedStepIndex].body === ''){
            notifyErrorInBottom('Please fill the Message body Field');
            return;
        } else {
            try{
                if(!email.length || error.length){
                    setError('To Field is required');
                } else {
                    setLoading(true);
                    const payload = {
                        campaign_id: props.campaignID,
                        subject: props.steps[props.selectedStepIndex].subject,
                        body: props.messageMimeType === 'text/html' ? props.steps[props.selectedStepIndex].body : convertHtmlToPlainText(props.steps[props.selectedStepIndex].body),
                        email:email,
                        mime_type:props.messageMimeType
                    }
                    
                    const response = await api.post("/v1/campaign/testsend",payload);
                    if(response.status === 200 || response.status === 201){
                        notifySuccess('Test email sent successfully.');
                    }
                    setTimeout(()=>{
                        props.setToggleSendTestModelWindow(false);
                    },1500);
                }
            } catch(error){
                console.log("error.message",error);
                if(error.status === 400){
                    notifyError('Bad Request. Unable to send a test email. Please try again.');
                }
                setLoading(false);
            } finally {
                setLoading(false);
            }
        }
    }

    return(<>
        <div className="model-window">
        <div className="overlay"></div>
        <div className="model-view">
            <div className="inner-view">
                <h2>Send a test email</h2>
                <p>Note: If the "From" address in this campaign matches the one below, your email might appear in the "Sent" folder rather than the "Inbox."</p>
                <div className="field-wrap">
                    <label className="label-xs">To:</label>
                    <input 
                        type="text" 
                        value={email} 
                        onChange={inputFieldChange} 
                        onBlur={onBlur}
                        onFocus={onFocus}
                        />
                        {error.length ? <span className="validation-error">{error}</span>:''}
                </div>
                {props?.assignedInfo?.status !== "active" ? <>
                    <div className="assign-mail-info">
                        <p><i className='bx bxs-x-circle'></i> Can not send the test email. Please check assigned mail account.</p>
                    </div>
                </>:''}
                <div className="button-group">
                    <button 
                        type="button" 
                        className={loading ? "delete-btn button--loading":"delete-btn"} 
                        disabled={loading}
                        onClick={()=>{actionSendTestMessage()}}>
                            <span className="button--text">Send</span>
                    </button>                        
                    <button className="cancel-btn" onClick={()=>props.setToggleSendTestModelWindow(!props.toggleSendTestModelWindow)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
    </>);
}
export default SendTestMessageModelWindow;